import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/nUCZkbt3qTWGgu1PA"
            >
              <CFImage
                src={mobileMap}
                style="display:block"
                w="100%"
                alt="Isshin Sushi Location"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/nUCZkbt3qTWGgu1PA"
            >
              <CFImage
                style="display:block"
                src={locationMap}
                w="100%"
                alt="Isshin Sushi Location"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
